import React, { useCallback, useEffect } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";

require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const LineChartAR:  any = (props:any) => {
    //console.log(props);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton, dataDefault, onChangeSelect, colores} = props;
	//console.log(`TITULO ::: ${title}`)
	// console.log(allData)
	
	const options = {
		chart:{
			// height: formatter: function() { return seriesData[this.value][0];},
			height: '65%', // 16:9 ratio
			type:'spline',
			backgroundColor: '#f0f0f0',
			colorCount: 15,
		},

		title: {
			text: title
		},
	
		// subtitle: {
		// 	text: 'Marcas Ciudadanas'
		// },
	
		yAxis: {
			title: "enabled"
			, reversed: false,
			labels:{
				format: '{value}%'
			}
		},
		
		// xAxis: {
		// 	tickInterval: 1,
		// 	labels: {
		// 		enabled: true,
		// 		// formatter: function() { 
		// 		// 	// console.log(allData)
		// 		// 	console.log(this)
		// 		// 	// return allData[series.name][0];
		// 		// },
		// 	}
		// },
		xAxis: { categories : labels },
		// xAxis: {
		// 	categories : ["Enero S3",
        //     "Febrero S2",
        //     "Febrero S4",
        //     "Marzo s1",
        //     "Marzo s2"],
		// },
	
		plotOptions: {
			series: {
				dataLabels: {
				align: 'right',
				enabled: true,
				inside: false
				},
				grouping: true
			}
		},

		tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}%</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},
	

		series: allData,
		colors: colores,

		responsive: {  
			rules: [{  
				condition: {  
				maxWidth: 1000
				},  
				chartOptions: {
				legend: {
					align: 'right',
					verticalAlign: 'bottom',
					layout: 'horizontal'
				},
				subtitle: {
					text: null
				},
				credits: {
					enabled: false
				}
			}
			}]  
			},
		
			lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
			},

			exporting: {
			enabled: true, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						//console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						//"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}

	}
	// useEffect(() => {
	// 	console.log("Paso")
	// 	// console.log(allData)
	// 	// console.log(dataDefault)
	// 	if ( allData[0]['label'] ==  '' ) {
	// 		if ( dataDefault.length === 2 ){
	// 			onChangeSelect(dataDefault);
	// 		}
	// 	} 
	// }, [dataDefault])

	return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default LineChartAR;